import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FabricatorRewardsRoutingModule } from './fabricator-rewards-routing.module';
import { FabricatorRewardsComponent } from './fabricator-rewards.component';
import { HeaderFabricatorRewardsComponent } from '../../components/header-fabricator-rewards/header-fabricator-rewards.component';
import { FooterFabricatorRewardsComponent } from '../../components/footer-fabricator-rewards/footer-fabricator-rewards.component';
import { InformationFabricatorRewardsComponent } from '../../components/information-fabricator-rewards/information-fabricator-rewards.component';
import { ItemInformationRewardsComponent } from '../../components/item-information-rewards/item-information-rewards.component';
import { TableInformationRewardsComponent } from '../../components/table-information-rewards/table-information-rewards.component';
import { TableRewardsComponent } from '../../components/table-rewards/table-rewards.component';


@NgModule({
  declarations: [
    FabricatorRewardsComponent
  ],
  imports: [
    CommonModule,
    FabricatorRewardsRoutingModule,
    HeaderFabricatorRewardsComponent,
    InformationFabricatorRewardsComponent,
    ItemInformationRewardsComponent,
    TableInformationRewardsComponent,
    FooterFabricatorRewardsComponent, 
    TableRewardsComponent
  ]
})
export class FabricatorRewardsModule { }
